import styled from 'styled-components'
import { P2, CobaltText, ErrorTypography } from '../../styled/typography/typography'

export const P2ChangePassword = styled(P2)`
  margin-top: 15px;
`

export const CobaltTextChangePassword = styled(CobaltText)`
  display: block;
  cursor: pointer;
  margin-top: 19px;
  font-size: 13px;
  font-weight: 500;
`

export const ChangePasswordError = styled(ErrorTypography)`
  position: absolute;
  top: -20px;
  left: 150px;
`

export const VoluntaryForm = styled.form`
  padding: 0;
  text-align: left;

  .password-container {
    width: 100%;

    input {
      width: 100%;
      margin-bottom: 2px;
    }

    .toggle-password {
      position: absolute;
      right: 10px;
    }
  }

  &>div:not(:last-child) {
    margin-bottom: 10px;
  }
`
